// extracted by css-extract-rspack-plugin
export default {"DismissibleFlashContainer":"DismissibleFlash-module__DismissibleFlashContainer__aXRcq","dismissButton":"DismissibleFlash-module__dismissButton__HiG83"};